const fvData = {
  brand: "الأذكار المفضلة",
};

export default fvData;
